import React from 'react'
import {
  RouterProvider,
  createBrowserRouter,
}
from 'react-router-dom'

/**
 * Components
 */
import Modals from '@components/modals'
import Container from '@react/container'

/**
 * Pages
 */
import Error from '@pages/error'
import AuditLog from '@pages/audit'
import Reports from '@pages/reports'
import Login from '@pages/auth/login'
import Reset from '@pages/auth/reset'
import Forgot from '@pages/auth/forgot'
import Register from '@pages/auth/register'
import Tickets from '@pages/tickets'
import Accounts from '@pages/accounts'
import Dashboard from '@pages/dashboard'
import Blocked from '@pages/posts/blocked'
import Reported from '@pages/posts/reported'
import Published from '@pages/posts/published'
import Spaces from '@pages/organizations/spaces'
import Groups from '@pages/organizations/groups'
import Businesses from '@pages/organizations/businesses'
import GeneralSettings from '@pages/settings/general'
import ContentSettings from '@pages/settings/content'
import ControlsSettings from '@pages/settings/controls'

/**
 * Styles
 */
import '@assets/sass/global.scss'
import '@assets/sass/layout.scss'
import '@assets/sass/common.scss'


/**
 * Routes
 */
export default function Router() {
  return (
    <React.Fragment>
      <RouterProvider
        router={createBrowserRouter([
          {
            path: '/',
            element: <Login/>,
            errorElement: <Error/>,
          },
          {
            path: '/organization/register',
            element: <Register/>
          },
          {
            path: '/auth',
            children: [
              {
                path: 'reset',
                element: <Reset/>,
              },
              {
                path: 'forgot',
                element: <Forgot/>
              },
            ]
          },
          {
            path: '/office',
            element: <Container/>,
            children: [
              {
                path: 'dashboard',
                element: <Dashboard/>
              },
              {
                path: 'accounts',
                element: <Accounts/>
              },
              {
                path: 'posts',
                children: [
                  {
                    path: 'published',
                    element: <Published/>
                  },
                  {
                    path: 'blocked',
                    element: <Blocked/>
                  },
                  {
                    path: 'reported',
                    element: <Reported/>
                  }
                ]
              },
              {
                path: 'organizations',
                children: [
                  {
                    path: 'businesses',
                    element: <Businesses/>
                  },
                  {
                    path: 'spaces',
                    element: <Spaces/>
                  },
                  {
                    path: 'groups',
                    element: <Groups/>
                  },
                ]
              },
              {
                path: 'audit-log',
                element: <AuditLog/>
              },
              {
                path: 'reports',
                element: <Reports/>
              },
              {
                path: 'controls',
                element: <ControlsSettings/>
              },
              {
                path: 'support/tickets',
                element: <Tickets/>
              },
              {
                path: 'settings',
                children: [
                  {
                    path: 'general',
                    element: <GeneralSettings/>
                  },
                  {
                    path: 'content',
                    element: <ContentSettings/>
                  }
                ]
              },
            ]
          },
        ]
      )}/>
      <Modals/>
    </React.Fragment>
  )
}